import { logout } from "../redux/services/auth.service";
import { CLEAR_FORM_STATE } from "../redux/actions/applicationType";

export const performLogout = (dispatch) => {
  dispatch({
    type: CLEAR_FORM_STATE
  });
  localStorage.setItem("LOGOUT_TRIGGER", Date.now());
  localStorage.setItem("LAST_ACTIVITY", Date.now());
  dispatch(logout());
};
